var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7.25L11 11.75L20.25 7.25",
    stroke: "#192643",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.99999V2.75C5.25 2.1975 5.6975 1.75 6.25 1.75H15.75C16.3025 1.75 16.75 2.1975 16.75 2.75V8.99999",
    stroke: "#192643",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.16945L19.5165 5.81445C19.971 6.08495 20.25 6.57495 20.25 7.10395V14.7504C20.25 16.1309 19.1305 17.2504 17.75 17.2504H4.25C2.8695 17.2504 1.75 16.1309 1.75 14.7504V7.10344C1.75 6.57444 2.0285 6.08445 2.4835 5.81395L5.25 4.16895",
    stroke: "#192643",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email-open.2cc76a9b7c4939f564a685889e851ee1.svg";
export { ForwardRef as ReactComponent };